import { render } from "./Enigme5.vue?vue&type=template&id=75615c2c"
import script from "./Enigme5.vue?vue&type=script&lang=js"
export * from "./Enigme5.vue?vue&type=script&lang=js"

import "./Enigme5.vue?vue&type=style&index=0&id=75615c2c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__